let capitolRepFinder = document.querySelector("#capitolRepFinder");
let capitolReps = [];
let storedReps = JSON.parse(localStorage.getItem("capitolReps"));

function addRepCard(rep) {
  var container = document.querySelector(".capitol-reps");
  var template = document.querySelector('#capitolRepCard');

  var card = template.content.cloneNode(true);
  var repName = card.querySelector(".repName");
  var repPhoto = card.querySelector(".repPhoto");
  var congressSeal = '/themes/custom/nada/images/Seal_of_the_United_States_Congress.svg';
  var senateSeal = '/themes/custom/nada/images/Seal_of_the_United_States_Senate.svg';
  var houseSeal = '/themes/custom/nada/images/Seal_of_the_United_States_House_of_Representatives.svg';

  repName.textContent = rep.name;

  if (rep.urls) {
    var sealPhoto = rep.urls[0].includes('house') ? houseSeal : senateSeal;
    rep.photoUrl ? repPhoto.setAttribute('src', rep.photoUrl) : repPhoto.setAttribute('src', sealPhoto);
  } else {
    rep.photoUrl ? repPhoto.setAttribute('src', rep.photoUrl) : repPhoto.setAttribute('src', congressSeal);
  }

  container.appendChild(card);
}

function revealRepCards() {
  let cards = document.querySelectorAll('.capitol-rep');
  Array.prototype.forEach.call(cards, function (card, i) {
    card.classList.remove('opacity-0');
  });
}

function hideRepCards() {
  let cards = document.querySelectorAll('.capitol-rep');
  Array.prototype.forEach.call(cards, function (card, i) {
    card.classList.add('opacity-0');
  });
}

function getCapitolReps(form) {
  // Clear existing capitol reps before getting new ones
  hideRepCards();
  capitolReps = [];
  localStorage.setItem("capitolReps", '');
  document.querySelector('.capitol-reps').innerHTML = '';

  let apiKey = 'AIzaSyDl3PSvyzoaV8C8Qpg84OO1WR9aNAkQ9js';
  let civicsURL = 'https://www.googleapis.com/civicinfo/v2/representatives';
  let address = form.address.value;
  let zipcode = form.zipcode.value;

  // Fetch reps from Google Civics API https://developers.google.com/civic-information/docs/v2
  fetch(civicsURL + '?address=' + address + ' ' + zipcode + '&levels=country&roles=legislatorLowerBody&roles=legislatorUpperBody&key=' + apiKey)
    .then(response => response.json())
    .then(data => {
      Array.prototype.forEach.call(data.officials, function (rep, i) {
        capitolReps.push(rep);
        addRepCard(rep);
      });
      localStorage.setItem("capitolReps", JSON.stringify(capitolReps));
    });
}

// Only do something if the page has the capitol rep finder block
if (capitolRepFinder) {

  // Load any locally stored reps first
  if (storedReps) {
    Array.prototype.forEach.call(storedReps, function (rep, i) {
      addRepCard(rep);
    });
    revealRepCards();
  }

  // Get the address form and listen for an address update
  let addressForm = capitolRepFinder.querySelector('#addressForm');
  addressForm.addEventListener('submit', function (e) {
    e.preventDefault();
    getCapitolReps(addressForm);
    revealRepCards();
  })

  // Wait for the page to finish loading, then attach Places Autocomplete Search
  document.addEventListener('DOMContentLoaded', () => {
    let input = document.querySelector('#address');
    let autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.setFields(["adr_address"]);
  })
}
